module.exports = __webpack_public_path__ + "static/media/232-yemen.ccc4b562.svg";